(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-product-features"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('blocky-slider-1')) {
  customElements.define('blocky-slider-1',
    class BlockySlider1 extends HTMLElement {
      connectedCallback() {
        if (this.dataset.blockyInit === 'true') return;
        this.dataset.blockyInit = 'true';

        const nextButton = this.querySelector('[data-blocky-next]');
        const prevButton = this.querySelector('[data-blocky-prev]');

        if (!nextButton || !prevButton) return;

        nextButton.addEventListener('click', () => this.showSlider('next'));
        prevButton.addEventListener('click', () => this.showSlider('prev'));
      }

      showSlider(type) {
        const listHTML = this.querySelector('.blocky-slider-container');
        if (!listHTML) return;

        this.classList.remove('next', 'prev');
        const items = this.querySelectorAll('.slide');
        if (items.length < 2) return;

        if (type === 'next') {
          listHTML.appendChild(items[0]);
          this.classList.add('next');
        } else {
          listHTML.prepend(items[items.length - 1]);
          this.classList.add('prev');
        }
      }
    }
  )
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
